<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="18"
    viewBox="0 0 17 18"
    fill="none"
  >
    <path
      d="M15.3516 7.21497C16.6849 7.98477 16.6849 9.90927 15.3516 10.6791L3.35156 17.6073C2.01823 18.3771 0.351564 17.4148 0.351564 15.8752L0.351564 2.01882C0.351564 0.479218 2.01823 -0.483033 3.35156 0.286768L15.3516 7.21497Z"
      fill="#522178"
    />
  </svg>
</template>
